import { db } from '../../firebase/config';
import { client } from '../../hooks/Client';
import notDeleted from '../notDeleted';

// Zijn er al antwoorden, op één meetmoment, in één onderzoek of op één vraag?
//
// Nodig omdat twee plekken dezelfde vraag stellen: useMomentHasResponses (per
// meetmoment) en de schakelaar 'Schuifbalk in plaats van rondjes' (per
// onderzoek, testronde 2026-10-15 B3). Eerst stond de query alleen in de hook.
// Per vraag (FieldID): de indicatoren in het TOC-detail (inbox #328).
//
// Bewust alleen JA/NEE en geen telling: tellen betekent élk antwoorddocument
// ophalen (respondenten × vragen, al gauw duizenden). Een paar documenten zijn
// genoeg om te weten dát er antwoorden zijn.
// AI-CONTEXT: See docs/pitfalls.md#database-missing-compagnyid-on-fresh-fetch

// Ruim boven 1, zodat een handvol soft-deleted antwoorden niet leidt tot
// 'geen antwoorden' terwijl er wel degelijk is ingevuld.
const PROBE_SIZE = 10;

/**
 * @param {'MomentID'|'ResearchID'|'FieldID'} field - Waarop de antwoorden gezocht worden
 * @param {string} value - Het ID van het meetmoment, onderzoek of de vraag
 * @returns {Promise<boolean>} Gooit bij een mislukte query, zodat de aanroeper
 *   'weet ik niet' kan onderscheiden van 'geen antwoorden'
 */
const probeHasResponses = async (field, value) => {
    const snapshot = await db.collection('QuestionnairesResponses')
        .where('CompagnyID', '==', client)
        .where(field, '==', value)
        .limit(PROBE_SIZE)
        .get();

    return snapshot.docs.some((doc) => notDeleted(doc.data()));
};

export default probeHasResponses;
